export default "/kiban/_next/static/images/btn_orderdatab-999c9cf36e5b99bc8140ae3fd8a0b2e5.png";